/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A countdown shows how much time is left until a moment you care about — a holiday, a launch, a deadline or a birthday. Choose the target date and time and the tool works out the difference from your device's current clock, then updates it once a second so the seconds tick down live.

If the target has already passed, the display flips to show how long ago it was instead. Everything runs locally against your own clock, so the countdown is as accurate as your device's time.`)
};

const es_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una cuenta atrás muestra cuánto tiempo queda hasta un momento que te importa — unas vacaciones, un lanzamiento, una fecha límite o un cumpleaños. Elige la fecha y hora objetivo y la herramienta calcula la diferencia con el reloj actual de tu dispositivo, actualizándola cada segundo para que los segundos bajen en vivo.

Si el objetivo ya ha pasado, la pantalla cambia para mostrar cuánto tiempo hace que ocurrió. Todo funciona localmente con tu propio reloj, así que la cuenta atrás es tan precisa como la hora de tu dispositivo.`)
};

const de_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Countdown zeigt, wie viel Zeit bis zu einem Moment verbleibt, der dir wichtig ist — ein Feiertag, ein Launch, eine Frist oder ein Geburtstag. Wähle Zieldatum und Uhrzeit, und das Tool berechnet die Differenz zur aktuellen Uhrzeit deines Geräts und aktualisiert sie jede Sekunde, sodass die Sekunden live herunterzählen.

Ist der Zielzeitpunkt bereits vergangen, wechselt die Anzeige und zeigt stattdessen, wie lange er schon zurückliegt. Alles läuft lokal anhand deiner eigenen Uhr, sodass der Countdown so genau ist wie die Uhrzeit deines Geräts.`)
};

const nl_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een aftelling laat zien hoeveel tijd er nog rest tot een moment dat voor jou belangrijk is — een feestdag, een lancering, een deadline of een verjaardag. Kies de doeldatum en -tijd en de tool berekent het verschil met de huidige klok van je apparaat, en werkt dit elke seconde bij zodat de seconden live wegtellen.

Als het doel al is verstreken, schakelt de weergave om en laat zien hoe lang het geleden is. Alles draait lokaal op basis van je eigen klok, dus de aftelling is zo nauwkeurig als de tijdsinstelling van je apparaat.`)
};

const fr_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un compte à rebours indique le temps restant avant un moment qui vous tient à cœur — des vacances, un lancement, une échéance ou un anniversaire. Choisissez la date et l'heure cible et l'outil calcule la différence avec l'horloge actuelle de votre appareil, puis la met à jour chaque seconde pour un décompte en direct.

Si la date cible est déjà passée, l'affichage bascule pour montrer depuis combien de temps c'était. Tout fonctionne localement selon votre propre horloge, donc le compte à rebours est aussi précis que l'heure de votre appareil.`)
};

const it_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un conto alla rovescia mostra quanto tempo manca a un momento a cui tieni — una festività, un lancio, una scadenza o un compleanno. Scegli la data e l'ora obiettivo e lo strumento calcola la differenza dall'orologio attuale del tuo dispositivo, poi la aggiorna una volta al secondo in modo che i secondi scorrano dal vivo.

Se l'obiettivo è già passato, la visualizzazione passa a mostrare da quanto tempo è successo. Tutto funziona localmente in base al tuo orologio, quindi il conto alla rovescia è preciso quanto l'orologio del tuo dispositivo.`)
};

const pt_br2_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma contagem regressiva mostra quanto tempo falta até um momento importante para você — um feriado, um lançamento, um prazo ou um aniversário. Escolha a data e hora alvo e a ferramenta calcula a diferença com base no relógio atual do seu dispositivo, atualizando a cada segundo para que os segundos passem ao vivo.

Se a data já passou, a exibição muda para mostrar há quanto tempo isso ocorreu. Tudo roda localmente contra o seu próprio relógio, então a contagem é tão precisa quanto o horário do seu dispositivo.`)
};

const pt_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma contagem decrescente mostra quanto tempo falta até um momento que lhe importa — um feriado, um lançamento, um prazo ou um aniversário. Escolha a data e hora alvo e a ferramenta calcula a diferença a partir do relógio atual do seu dispositivo, atualizando-a a cada segundo para que os segundos avancem ao vivo.

Se o alvo já tiver passado, a apresentação muda para mostrar há quanto tempo foi. Tudo acontece localmente com base no seu próprio relógio, pelo que a contagem decrescente é tão precisa quanto a hora do seu dispositivo.`)
};

const ja_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カウントダウンは、休日、発売日、締め切り、誕生日など大切な瞬間までの残り時間を表示します。目標の日時を選ぶと、ツールが端末の現在時刻との差を計算し、1秒ごとに更新して秒数がリアルタイムでカウントダウンされます。

目標日時がすでに過ぎている場合は、表示が切り替わり、代わりにどれくらい前だったかを示します。すべてお使いの端末の時計に基づいてローカルで処理されるため、カウントダウンの正確さは端末の時刻設定次第です。`)
};

const zh_cd_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倒计时显示距离你所关心的时刻——假期、发布日、截止日期或生日——还剩多少时间。选择目标日期和时间，工具会根据你设备的当前时间计算差值，并每秒更新一次，让秒数实时跳动。

如果目标时刻已经过去，显示会切换为显示已经过去了多久。整个过程都基于你自己设备的时钟本地运行，因此倒计时的准确度取决于设备时间的准确度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_howto = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_howto(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_howto", locale)
	if (locale === "en") return en_cd_howto(inputs)
	if (locale === "es") return es_cd_howto(inputs)
	if (locale === "de") return de_cd_howto(inputs)
	if (locale === "nl") return nl_cd_howto(inputs)
	if (locale === "fr") return fr_cd_howto(inputs)
	if (locale === "it") return it_cd_howto(inputs)
	if (locale === "pt-BR") return pt_br2_cd_howto(inputs)
	if (locale === "pt") return pt_cd_howto(inputs)
	if (locale === "ja") return ja_cd_howto(inputs)
	return zh_cd_howto(inputs)
};